import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  theme => ({
    rootContainer: {
      padding: theme.spacing(1, 0.5),
      "& h5": {
        fontWeight: 700,
        color: "#1e2e45",
        letterSpacing: "-0.01em",
      },
    },
    subtitle: {
      color: theme.palette.text.secondary,
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(4),
      fontSize: "0.92rem",
    },
    error: {
      color: theme.palette.error.main,
      fontWeight: 600,
      fontSize: "0.875rem",
      marginTop: theme.spacing(0.5),
    },
    fieldRow: {
      marginTop: theme.spacing(2.5),
    },
    submit: {
      marginTop: theme.spacing(3),
      minWidth: 200,
      height: 44,
      fontWeight: 600,
      fontSize: "0.95rem",
      letterSpacing: "0.02em",
      borderRadius: 5,
      background: "linear-gradient(90deg, #2a4468 0%, #315179 100%)",
      boxShadow: "0 2px 8px rgba(49,81,121,0.25)",
      "&:hover": {
        background: "linear-gradient(90deg, #233a5a 0%, #2a4468 100%)",
        boxShadow: "0 4px 12px rgba(49,81,121,0.35)",
      },
    },
    submitHelp: {
      marginTop: 20,
      textAlign: "center",
    },
  }),
  {
    classNamePrefix: "LoginPage",
  },
);